import connectAutocomplete from 'instantsearch.js/es/connectors/autocomplete/connectAutocomplete'
import type { AutocompleteConnectorParams, AutocompleteWidgetDescription } from 'instantsearch.js/es/connectors/autocomplete/connectAutocomplete'
import { useConnector } from 'react-instantsearch'

type UseAutocompleteProps = AutocompleteConnectorParams

export const useAutocomplete = (props?: UseAutocompleteProps) => {
  return useConnector<AutocompleteConnectorParams, AutocompleteWidgetDescription>(connectAutocomplete, props)
}
